import { render } from "./aiVideoScript.vue?vue&type=template&id=16d8dc3d&scoped=true"
import script from "./aiVideoScript.vue?vue&type=script&setup=true&lang=js"
export * from "./aiVideoScript.vue?vue&type=script&setup=true&lang=js"

import "./aiVideoScript.vue?vue&type=style&index=0&id=16d8dc3d&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16d8dc3d"],['__file',"src/views/exhibitionManage/aiVideoScript.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "16d8dc3d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('16d8dc3d', __exports__)) {
    console.log('reload')
    api.reload('16d8dc3d', __exports__)
  }
  
  module.hot.accept("./aiVideoScript.vue?vue&type=template&id=16d8dc3d&scoped=true", () => {
    console.log('re-render')
    api.rerender('16d8dc3d', render)
  })

}


export default __exports__